export default __webpack_public_path__ + "static/media/hatchdrawing.7369b604.png";